import { render, staticRenderFns } from "./insuranceFund.vue?vue&type=template&id=38960674"
import script from "./insuranceFund.vue?vue&type=script&lang=js"
export * from "./insuranceFund.vue?vue&type=script&lang=js"
import style0 from "./insuranceFund.vue?vue&type=style&index=0&id=38960674&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports